import React from 'react'
import {
    TextArea, CellBody, Form, FormCell, Button,
    Toast, Dialog, Toptips,
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { browserHistory } from 'react-router'
import {WKTextarea} from '../../components/wk'
import Header from '../../components/liveroomLecturer/Header'
import '../../css/page/ChannelEditPage.css'


class ChannelEditTitlePage extends React.Component {
    constructor (props) {
        super(props)
        this.type = /^\/lecture\//.test(props.location.pathname) ? 'lecture' : 'channel'
        this.state = {
            title: '',
            subTitle: '',
            hasSubTitle: false,
            isPending: false,
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        this.fetchTitles()
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    fetchTitles () {
        this.setState({ isPending: true })
        axios.get(`/api/${this.type}/${this.props.params.id}/edit_info`)
            .then(res => {
                this.setState({
                    title: res.data.data[this.type].name,
                    subTitle: res.data.data[this.type].subtitle,
                    hasSubTitle: !!res.data.data[this.type].subtitle,
                    isPending: false,
                })
            })
    }
    onClickAlertOk () {
        if (/is_from_info/.test(location.search)) {
            location.assign(`/${this.type}2/${this.props.params.id}?_t=${Date.now()}`)
        } else {
            browserHistory.go(-1)
        }
    }
    bindValue (e, field) {
        const value = e.target.value
        this.setState({ [field]: value })
    }
    onSubmit (e) {
        const title = this.state.title.trim()
        const typeName = this.type === 'lecture' ? '课程' : '专栏'
        if (title.length < 1 || title.length > 100) {
            return this.showTip(`标题长度请控制在1-40个字符之间`)
        }
        this.setState({ isPending: true })
        axios.post(`/api/${this.type}/${this.props.params.id}/edit`, qs.stringify({
            name: this.state.title,
            subtitle: this.state.subTitle,
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.setState({
                    alertDialog: { isShow: true, text: '修改成功' }
                })
            })
    }
    render() {
        const typeName = this.type === 'lecture' ? '课程' : '专栏'
        const needSubtitle = this.type !== 'lecture' || this.state.hasSubTitle
        return (
            <div className='page'>
                <div className="wk-inner-page channel-edit-page">
                    <div className="title-page">

                        <Header title={`${typeName}标题`} />
                        <Form>
                            <FormCell>
                                <CellBody>
                                    <WKTextarea
                                        maxLength={40}
                                        value={this.state.title}
                                        showCounter={true}
                                        placeholder="标题长度1-40字符"
                                        required rows="3"
                                        onChange={e => this.bindValue(e, 'title')}
                                    >
                                    </WKTextarea>
                                </CellBody>
                            </FormCell>
                        </Form>
                        <p className="small-font intro">1-40个字符，好的标题更容易吸引用户关注和购买</p>

                        {/* 为还有副标题的项目做兼容，但是没有副标题的以后就再也没有副标题了 */}
                        { needSubtitle && <Header title={`${typeName}副标题`} /> }
                        { needSubtitle && <Form>
                            <FormCell>
                                <CellBody>
                                    <TextArea
                                        value={this.state.subTitle}
                                        showCounter={false}
                                        placeholder="请填写副标题"
                                        rows="3"
                                        onChange={e => this.bindValue(e, 'subTitle')}
                                    >
                                    </TextArea>
                                </CellBody>
                            </FormCell>
                        </Form> }
                        { needSubtitle && <p className="small-font intro">副标题作为标题的补充，展示在详情页面标题的下方，也用作分享链接时的文字说明</p> }

                        <div className="wk-btn-90 padding-top-10">
                            <Button onClick={e => this.onSubmit()}>保存</Button>
                        </div>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: 'Ok', onClick: () => this.onClickAlertOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}

export default ChannelEditTitlePage



// WEBPACK FOOTER //
// ./src/pages/ChannelEdit/ChannelEditTitlePage.js